import React, {Component} from 'react';
import Stations from './components/stations'
import './bootstrap.css';

class App extends Component {

  render() {
    return (
      <Stations />
    )
  }

}

export default App;
